var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashicons:pdf"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27999 22.4H7.99999V24H9.27999C9.75999 24 10.08 23.68 10.08 23.2C10.08 22.72 9.75999 22.4 9.27999 22.4ZM17.6 3.20001H4.79999V28.8H25.6V11.2L17.6 3.20001ZM11.52 23.36C11.52 24.64 10.56 25.6 9.27999 25.6H7.99999V27.2H6.39999V20.8H9.27999C10.56 20.8 11.52 21.76 11.52 23.04V23.36ZM18.08 24.16C18.08 25.76 16.8 27.2 15.04 27.2H12.8V20.8H15.04C16.64 20.8 18.08 22.08 18.08 23.84V24.16ZM24 22.4H20.8V24H23.2V25.6H20.8V27.2H19.2V20.8H24V22.4ZM24 19.2H6.39999V4.80001H17.6V11.2H24V19.2ZM15.04 22.4H14.4V25.6H15.04C16 25.6 16.64 24.96 16.64 24C16.64 23.04 15.84 22.4 15.04 22.4Z",
    fill: "#BCBEC1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c0fa9f1d4a996adc2be4d973a5fdc67a.svg";
export { ForwardRef as ReactComponent };